<template>
  <main class="bg-bg-bg-default flex min-h-screen items-center justify-center p-8">
    <slot />
  </main>
</template>
<script lang="ts" setup></script>
